const SHORTPAY_APP_ORIGIN = "https://app.getshortpay.com";

export interface ConfiguredOrigins {
  apiUrl: string;
  wsUrl: string;
}

export function joinOriginPath(origin: string, path: string): string {
  return `${origin.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}

export function getRuntimeOrigins(
  origin: string,
  configured: ConfiguredOrigins,
): ConfiguredOrigins {
  // Deliberately strict: the complete browser origin must be canonical. This
  // rejects non-default ports, lookalike hosts, trailing dots, alternate
  // schemes, and IPv4/IPv6 host tricks.
  if (origin === SHORTPAY_APP_ORIGIN) {
    return {
      apiUrl: SHORTPAY_APP_ORIGIN,
      wsUrl: SHORTPAY_APP_ORIGIN.replace(/^https:/, "wss:"),
    };
  }
  return configured;
}

export function browserRuntimeOrigins(configured: ConfiguredOrigins): ConfiguredOrigins {
  const origin = typeof window === "undefined" ? "" : window.location.origin;
  return getRuntimeOrigins(origin, configured);
}
